/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the PushSubscriptionKeys interface.
 */
export function instanceOfPushSubscriptionKeys(value) {
    let isInstance = true;
    return isInstance;
}
export function PushSubscriptionKeysFromJSON(json) {
    return PushSubscriptionKeysFromJSONTyped(json, false);
}
export function PushSubscriptionKeysFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'p256dh': !exists(json, 'p256dh') ? undefined : json['p256dh'],
        'auth': !exists(json, 'auth') ? undefined : json['auth'],
    };
}
export function PushSubscriptionKeysToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'p256dh': value.p256dh,
        'auth': value.auth,
    };
}
